import { CSSProperties } from 'react';

/**
 * Chrome shared by the inbox toolbar chips (sort dropdown, future-tasks
 * toggle) so they read as one control row. Restyle here, not per chip.
 */
export const INBOX_TOOLBAR_CHIP_STYLE: CSSProperties = {
  border: '1px solid #dee2e6',
  borderRadius: 8,
  padding: '6px 12px',
};
